import React from "react";
import { Box } from "@chakra-ui/react";

import { Header } from "./Layout";
import { Container } from "./Layout";
import { Home, About, Experience, Portfolio, Services, ReachMe } from "./Pages";
import { BackToTopButton } from "./Components";

const App = () => {
  return (
    <Box>
      <Header />
      <Container>
        <Home />
        <About />
        <Services />
        <Experience />
        <Portfolio />
        <ReachMe />
        <BackToTopButton />
      </Container>
    </Box>
  );
};

export default App;
